import gql from "graphql-tag";

export const UPDATE_SUBSCRIPTION = gql`
  mutation ($input: updateSubscriptionInput) {
    updateSubscription(input: $input)
  }
`;
